import axios from '@/plugins/axios'
import { useAppStore } from '@/stores/app'

export type NotificationsResponse = {
  data: App.Http.Resources.ApiV3.NotificationResource[];
  meta: {
    total: number;
    per_page: number;
    current_page: number;
    last_page: number;
    from: number;
    to: number;
  };
}

export default {
  baseUrl() {
    const appStore = useAppStore()

    return `${appStore.daraApiBaseUrl}/user-profiles/`
  },

  deleteUserProfile(userProfileId: number) {
    return axios.delete(this.baseUrl() + userProfileId)
  },

  updateUserProfile(userProfileId: number, data: object) {
    return axios.put(this.baseUrl() + userProfileId, data)
  },

  resendInvitation(userProfileId: number) {
    return axios.put(this.baseUrl() + userProfileId + '/resend-invitation/')
  },

  createTrialStudent(userProfileId: number) {
    return axios.post(this.baseUrl() + userProfileId + '/trial/')
  },

  notifications(userProfileId: number, page: number) {
    return axios.get<NotificationsResponse, NotificationsResponse>(this.baseUrl() + userProfileId + '/notifications/', {
      params: {
        page,
      },
    })
  },

  unreadNotifications(userProfileId: number) {
    return axios.get<App.Http.Resources.ApiV3.NotificationResource[]>(this.baseUrl() + userProfileId + '/unread-notifications/')
      .then(({ data }) => data)
  },
}
